import CheckinList from "./components/List"
import CheckinEnrol from "./components/Enrol"

let module = "checkin"

export default [
  { path: "checkin/:id", component: CheckinList, props: true, meta: { module: module, permissions: ["all"] } },
  {
    path: "checkin/enrol/:cid/:id",
    component: CheckinEnrol,
    props: true,
    meta: { module: module, permissions: ["all"] }
  }
]
